module.exports = __webpack_public_path__ + "files/5cb4d5bb8548d8978ac30453eabe2ade.png";